import {AfterContentInit, ContentChild, Directive, EventEmitter, Injector, Input, Output} from "@angular/core";
import {AbstractEditControlComponent} from "../abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {forkJoin, map} from "rxjs";
import {SelectOptionsComponent} from "../../../select/options/select-options.component";
import {FUISelectAction} from "@fedeltapointofsale/ui";
import {SearchModel} from "@fedeltapointofsale/data-client";

export function registerSelectEditControl(type: any): any[] {
    return [
        {provide: NG_VALUE_ACCESSOR, useExisting: type, multi: true},
        {provide: AbstractSelectEditControlComponent, useExisting: type, multi: true}
    ];
}

/**
 * Abstract class that implements methods for the select edit inputs
 */
@Directive()
export class AbstractSelectEditControlComponent <T extends SearchModel<any>> extends AbstractEditControlComponent implements AfterContentInit {
    @Input() extendedSearchComponentParams: any;
    @Input() extendedEditComponentParams: any;

    @Input() showOptionOpenOption: boolean = false;
    @Input() hideOptionOpenOption: boolean = false;

    @Output() onSelect: EventEmitter<any> = new EventEmitter();
    @Output() onClear: EventEmitter<any> = new EventEmitter();

    @ContentChild(SelectOptionsComponent) selectOptionsComponent: SelectOptionsComponent;

    extendedSearchComponent: any;
    extendedEditComponent: any;
    hideExtendedSearchOption: boolean = false;
    hideAddOption: boolean = false;
    showAddOption: boolean = false;
    actions: FUISelectAction[] = [];

    valueField: string;
    labelField: string;

    translateService: TranslateService;

    valueSearchField: string;
    labelSearchField: string;

    summaryLabelField: string;

    data: Array<any> = [];

    constructor(protected model: T, injector: Injector, valueField: string = "value", labelField: string = "label") {
        super(injector);
        this.translateService = injector.get(TranslateService, null);
        this.valueField = valueField;
        this.labelField = labelField;
    }

    ngAfterContentInit(): void {
        if (this.selectOptionsComponent) {
            this.subscriptions.add(this.selectOptionsComponent.data$.subscribe(data => {
                this.data = data;
                this.changeDetectorRef.detectChanges();
            }));
        }
    }

    buildData(options: { label: string, value?: any }[]): void {
        forkJoin(
            options.map(option =>
                this.translateService.get(option.label).pipe(
                    map(translation => ({
                        [this.labelField]: translation,
                        [this.valueField]: option.value === undefined ? translation : option.value
                    }))
                )
            )
        ).subscribe(results => this.data = results);
    }

    onDataLoaded(data: Array<any>): void {
    }

    onAction(action: FUISelectAction) {
    }

    onOptionOpen(option: any) {
    }
}
